module.exports = __webpack_public_path__ + "static/img/avatar-02.1b64af7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-02.jpg
// module id = u/QU
// module chunks = 22